import React from "react";
import { Route } from "react-router-dom";
import type { RouteCtx } from "../routeContext";
import { PlaceholderPage } from "../shell";
import {
  DataReviewPage,
  ExportsPage,
  StudyMilestones,
  MilestoneDetails,
  SiteActivation,
  CTMSReportsLanding,
  SettingsPage,
  SecurityPolicyPage,
  SiteFeasibilityPage,
  CDAManagement,
} from "../lazyPages";

/** fallbackAliasRoutes — order preserved for React Router first-match. */
export function fallbackAliasRoutes(ctx: RouteCtx): React.ReactNode {
  const { userRole, currentStudy, user } = ctx;

  return (
    <>
      {/* ── 4b. Fallback aliases (UNGATED — any authenticated role) ───── */}
      {/* Site Feasibility - Generic fallback routes */}
      <Route
        path="/site-feasibility"
        element={
          <SiteFeasibilityPage
            userRole={userRole}
            currentStudy={currentStudy}
          />
        }
      />
      <Route
        path="/ctms/site-feasibility"
        element={
          <SiteFeasibilityPage
            userRole={userRole}
            currentStudy={currentStudy}
          />
        }
      />
      <Route
        path="/cra/site-feasibility"
        element={
          <SiteFeasibilityPage
            userRole={userRole}
            currentStudy={currentStudy}
          />
        }
      />
      <Route
        path="/cta/site-feasibility"
        element={
          <SiteFeasibilityPage
            userRole={userRole}
            currentStudy={currentStudy}
          />
        }
      />
      <Route
        path="/sponsor/site-feasibility"
        element={
          <SiteFeasibilityPage
            userRole={userRole}
            currentStudy={currentStudy}
          />
        }
      />
      <Route
        path="/pm/site-feasibility"
        element={
          <SiteFeasibilityPage
            userRole={userRole}
            currentStudy={currentStudy}
          />
        }
      />
      <Route
        path="/dm/site-feasibility"
        element={
          <SiteFeasibilityPage
            userRole={userRole}
            currentStudy={currentStudy}
          />
        }
      />

      {/* CDA Management - Generic fallback routes */}
      <Route
        path="/cda-management"
        element={
          <CDAManagement userRole={userRole} currentStudy={currentStudy} />
        }
      />
      <Route
        path="/ctms/cda-management"
        element={
          <CDAManagement userRole={userRole} currentStudy={currentStudy} />
        }
      />

      {/* Site Activation - Generic fallback route */}
      <Route
        path="/site-activation"
        element={
          <SiteActivation userRole={userRole} currentStudy={currentStudy} />
        }
      />
      <Route
        path="/ctms/site-activation"
        element={
          <SiteActivation userRole={userRole} currentStudy={currentStudy} />
        }
      />
      <Route
        path="/cra/site-activation"
        element={
          <SiteActivation userRole={userRole} currentStudy={currentStudy} />
        }
      />
      <Route
        path="/sponsor/site-activation"
        element={
          <SiteActivation userRole={userRole} currentStudy={currentStudy} />
        }
      />
      <Route
        path="/pm/site-activation"
        element={
          <SiteActivation userRole={userRole} currentStudy={currentStudy} />
        }
      />
      <Route
        path="/pi/ctms/site-activation"
        element={
          <SiteActivation userRole={userRole} currentStudy={currentStudy} />
        }
      />

      {/* Study Milestones (ungated fallback) */}
      <Route path="/study-milestones" element={<StudyMilestones />} />
      <Route
        path="/study-milestones/:milestoneId"
        element={<MilestoneDetails />}
      />

      {/* CTMS Reports hub landing (ungated fallback) */}
      <Route
        path="/ctms-reports"
        element={<CTMSReportsLanding userRole={userRole} />}
      />

      {/* Data Review & Exports stubs (ungated fallback; role blocks may win first) */}
      <Route path="/data-review" element={<DataReviewPage />} />
      <Route path="/exports" element={<ExportsPage />} />

      {/* Documents - placeholder fallback */}
      <Route
        path="/documents"
        element={<PlaceholderPage title="Documents" />}
      />

      {/* Subjects - placeholder fallback */}
      <Route path="/subjects" element={<PlaceholderPage title="Subjects" />} />

      {/* eCRFs - placeholder fallback */}
      <Route path="/ecrfs" element={<PlaceholderPage title="eCRFs" />} />

      {/* Queries - placeholder fallback */}
      <Route path="/queries" element={<PlaceholderPage title="Queries" />} />

      {/* Settings (ungated; page components enforce Tenant Admin) */}
      <Route path="/settings" element={<SettingsPage user={user} />} />
      <Route
        path="/settings/security-policy"
        element={<SecurityPolicyPage user={user} />}
      />
    </>
  );
}
